/**
 * Created By Elia Rohana on 3/28/19
 */
import { State } from '@ispm-client/modules/bpmn-modeler/store/state';
import { Store } from '@ngrx/store';
import { UpdateNodeId } from '@ispm-client/modules/bpmn-modeler/store/actions/node-id-generator.action';

export class IdGenerator {
    private counter: number = 0;

    constructor(currentIdCounter: number, private store$: Store<State>) {
        this.counter = currentIdCounter;
    }

    public next(): number {
        const id = ++this.counter;
        this.store$.dispatch(new UpdateNodeId({ id}));
        return id;
    }
}
IdGenerator.$inject = ['config.currentIdCounter', 'store$'];

